import { createSlice } from '@reduxjs/toolkit'

const initialState= { 
  open: false,
  message: "",
  type: null,
  code: null
}

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openModal: (state, action)=>{
      state.open = true;
      state.message = action.payload.message || "Ha sucedido un error inesperado. Por favor contacte con el administrador.";
      state.type = action.payload.type || "error"
    state.code = action.payload.code
    },
    closeModal: (state)=>{
      state.open = false;
      state.message = ""
    }
  },
})

export const {openModal, closeModal} = modalSlice.actions

export default modalSlice.reducer
